<template>
   <div class="row career-testimonial">
      <div class="col-sm-12">
         <div v-if="isClient">
            <div v-swiper="swiperOptionTop"
                 class="gallery-top"
                 ref="swiperTop">
               <div class="swiper-wrapper">
                  <div class="swiper-slide"
                       v-for="(person, index) in testimonies"
                       :key="index">
                     <div class="testimonial">
                        <div class="quote d-flex align-items-center justify-content-center">
                           {{ person.quote }}
                        </div>
                        <div class="testimonialby">
                           <span class="t-name">{{ person.name }}</span>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="swiper-button-next testimonial-swiper-button-next">
                  <i class="fc_keyboard_arrow_right circular-button" />
               </div>
               <div class="swiper-button-prev testimonial-swiper-button-prev">
                  <i class="fc_keyboard_arrow_left circular-button" />
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'CareerTestimonial',
   props: {
      testimonies: {
         type: Array,
         required: false,
         default: () => [],
      },
   },
   data() {
      return {
         isClient: false,
         swiperOptionTop: {
            slidesPerView: 'auto',
            loop: true,
            loopAdditionalSlides: 1,
            spaceBetween: 15,
            centeredSlides: true,
            slideToClickedSlide: true,
            speed: 600,
            autoHeight: true,
            navigation: {
               nextEl: '.testimonial-swiper-button-next',
               prevEl: '.testimonial-swiper-button-prev',
            },
            breakpoints: {
               480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
               },
               568: {
                  slidesPerView: 2,
                  spaceBetween: 5,
               },

               800: {
                  slidesPerView: 2,
                  spaceBetween: 5,
               },

               1200: {
                  slidesPerView: 4,
                  spaceBetween: 5,
               },
            },
         },
      };
   },
   mounted() {
      this.isClient = true;
   },
};
</script>

<style lang="scss" scoped>
.swiper-slide {
   overflow: hidden;
   padding: 10px;
}

.testimonial {
   border: 1px solid rgba(62, 57, 107, 0);
   box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0);
   transition: all ease 1.2s;
   min-height: 250px;
   // padding: 0 4rem 2rem 4rem;
}
.swiper-slide-active {
   .testimonial {
      box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.1);
      border: 1px solid rgba(62, 57, 107, 0.04);
   }
}

.swiper-slide {
   @media (max-width: 800px) {
      .testimonial {
         background-position: center 2rem;
         .quote {
            font-size: 13px;
         }
      }
   }
   @media (max-width: 800px) {
      width: 75vw;
   }
   @media (max-width: 576px) {
      width: 80vw;
   }
   @media (max-width: 480px) {
      width: 80vw;
   }
}

.swiper-container {
   .circular-button {
      width: 40px;
      height: 40px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 9px 0 rgba(23, 28, 33, 0.12);
      line-height: 40px;
      border-radius: 50%;
      font-size: 30px;
   }
   @media (min-width: 800px) {
      &:before {
         content: '';
         width: 115px;
         height: 120%;
         display: block;
         position: absolute;
         z-index: 4;
         left: 0;
         top: 0;
         background: -moz-linear-gradient(
            left,
            rgba(255, 255, 255, 1) 29%,
            rgba(255, 255, 255, 0.42) 70%,
            rgba(255, 255, 255, 0) 100%
         );
         background: -webkit-linear-gradient(
            left,
            rgba(255, 255, 255, 1) 29%,
            rgba(255, 255, 255, 0.42) 70%,
            rgba(255, 255, 255, 0) 100%
         );
         background: linear-gradient(
            to right,
            rgba(255, 255, 255, 1) 29%,
            rgba(255, 255, 255, 0.42) 70%,
            rgba(255, 255, 255, 0) 100%
         );
         filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 );
      }
      &:after {
         content: '';
         width: 115px;
         height: 120%;
         display: block;
         position: absolute;
         z-index: 4;
         right: 0;
         top: 0;
         background: -moz-linear-gradient(
            left,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.42) 30%,
            rgba(255, 255, 255, 1) 71%
         );
         background: -webkit-linear-gradient(
            left,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.42) 30%,
            rgba(255, 255, 255, 1) 71%
         );
         background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.42) 30%,
            rgba(255, 255, 255, 1) 71%
         );
         filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 );
      }
   }
}
</style>
